import {
    AbstractControl,
    ValidatorFn
} from '@angular/forms';
import { DatiqInputErrorTypes } from '@dat/datiq-components-pkg/utils';

export function percentMaxCheck(
    value: number | string | null,
    maxValue: number
): { [key: string]: any } | null {
    const valueIsNumber: boolean = !isNaN(+value);
    const percentValue: number = valueIsNumber ? +value * 0.01 : 0;
    const valid: boolean = !valueIsNumber || percentValue <= maxValue * 0.01;

    return !!value && !valid
        ? {
              [DatiqInputErrorTypes.PercentMax]: {
                  value,
                  maxValue,
              },
          }
        : null;
}

export function percentMax(minValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        return percentMaxCheck(control.value, minValue);
    };
}
